var exports = {
  "U": "xe564cbfb--74459e--arrow_icon",
  "Q": "xe564cbfb--74459e--arrow_icon__open",
};

module.exports = exports;
